import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-sensor-gps-low')
export class ObiSensorGpsLow extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M3.86809 4.5755C3.47756 4.18497 3.47756 3.55181 3.86809 3.16128L5.98941 1.03996C6.37993 0.649439 7.0131 0.649439 7.40362 1.03996L11.6463 5.2826C12.0368 5.67313 12.0368 6.30629 11.6463 6.69682L11.2927 7.05037L11.9998 7.75748L14.8282 4.92905C15.2188 4.53853 15.8519 4.53853 16.2425 4.92905L19.0709 7.75748C19.4614 8.148 19.4614 8.78117 19.0709 9.17169L16.2425 12.0001L16.9496 12.7072L17.3031 12.3537C17.6936 11.9631 18.3268 11.9631 18.7173 12.3537L22.96 16.5963C23.3505 16.9868 23.3505 17.62 22.96 18.0105L20.8387 20.1318C20.4481 20.5224 19.815 20.5224 19.4244 20.1318L15.1818 15.8892C14.7913 15.4987 14.7913 14.8655 15.1818 14.475L15.5353 14.1214L14.8282 13.4143L13.414 14.8285C13.0235 15.2191 12.3903 15.2191 11.9998 14.8285L9.17139 12.0001C8.78086 11.6096 8.78086 10.9764 9.17139 10.5859L10.5856 9.17169L9.8785 8.46458L9.52494 8.81814C9.13442 9.20866 8.50125 9.20866 8.11073 8.81814L3.86809 4.5755Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.86809 4.5755C3.47756 4.18497 3.47756 3.55181 3.86809 3.16128L5.98941 1.03996C6.37993 0.649439 7.0131 0.649439 7.40362 1.03996L11.6463 5.2826C12.0368 5.67313 12.0368 6.30629 11.6463 6.69682L11.2927 7.05037L11.9998 7.75748L14.8282 4.92905C15.2188 4.53853 15.8519 4.53853 16.2425 4.92905L19.0709 7.75748C19.4614 8.148 19.4614 8.78117 19.0709 9.17169L16.2425 12.0001L16.9496 12.7072L17.3031 12.3537C17.6936 11.9631 18.3268 11.9631 18.7173 12.3537L22.96 16.5963C23.3505 16.9868 23.3505 17.62 22.96 18.0105L20.8387 20.1318C20.4481 20.5224 19.815 20.5224 19.4244 20.1318L15.1818 15.8892C14.7913 15.4987 14.7913 14.8655 15.1818 14.475L15.5353 14.1214L14.8282 13.4143L13.414 14.8285C13.0235 15.2191 12.3903 15.2191 11.9998 14.8285L9.17139 12.0001C8.78086 11.6096 8.78086 10.9764 9.17139 10.5859L10.5856 9.17169L9.8785 8.46458L9.52494 8.81814C9.13442 9.20866 8.50125 9.20866 8.11073 8.81814L3.86809 4.5755Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-sensor-gps-low': ObiSensorGpsLow;
  }
}
